import { BodyTextL, GRAY50, SB } from 'global-styles';
import Link from 'next/link';
import styled from 'styled-components';

interface Props {
  locale: string;
}

const featureText = {
  ko: '블루닷의 인지화질 최적화 제품과 연동하여 추가적인 압축 효율 향상이 가능합니다.',
  en: "It is possible to further improve the encoding efficiency by taking advantage of BLUEDOT's AI based Perceptual Quality Optimizer.",
};

const label = {
  ko: 'PQO 살펴보기',
  en: 'See the details of DeepField-PQO',
};

const href = {
  ko: '/product/pqo/#product-section',
  en: '/product/pqo/#product-section',
};

const Av1PQOCustomLink = ({ locale }: Props) => {
  return (
    <Av1PQOCustomLinkContainer>
      <BodyTextL className="feature-t">
        {featureText[locale]}
        <Link href={href[locale]} locale={locale}>
          <a className="pqo-link">{label[locale]}</a>
        </Link>
      </BodyTextL>
    </Av1PQOCustomLinkContainer>
  );
};

export default Av1PQOCustomLink;

const Av1PQOCustomLinkContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${GRAY50};
  .pqo-link {
    color: ${SB};
    font-size: 18px;
    font-weight: 400;
    line-height: 32px;
    font-family: 'Noto Sans KR';
    margin-left: 8px;
    letter-spacing: -0.01em;
    text-decoration-line: underline;
  }
`;
